import { useMemo } from 'react'
import { Box, Text } from '@chakra-ui/react'

import CustomFormAnswerUnifiedPerson from './components/CustomFormAnswerUnifiedPerson'
import CustomFormAnswerCommonEntity from './components/CustomFormAnswerCommonEntity'
import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import CustomFormAnswerJobsite from './components/CustomFormAnswerJobsite'
import CustomFormAnswerRole from './components/CustomFormAnswerRole'
import CustomFormAnswerSalary from './components/CustomFormAnswerSalary'
import CustomFormAnswerCostCenter from './components/CustomFormAnswerCostCenter'
import CustomFormAnswerProfessionalContractType from './components/CustomFormAnswerProfessionalContractType'

type KeyStringWithElement = {
  [key: string]: JSX.Element
}

export default function CustomFormEntitiesAnswer() {
  const { answer } = useCustomFormAnswer()

  const RenderEntityComponent = useMemo(() => {
    if (!answer.answer) return <Box />
    const possibleEntities: KeyStringWithElement = {
      UNIFIED_PERSON: <CustomFormAnswerUnifiedPerson />,
      JOBSITE: <CustomFormAnswerJobsite />,
      ROLE: <CustomFormAnswerRole />,
      SALARY: <CustomFormAnswerSalary />,
      COST_CENTER: <CustomFormAnswerCostCenter />,
      PROFESSIONAL_CONTRACT_TYPE: <CustomFormAnswerProfessionalContractType />,
      CITY: <CustomFormAnswerCommonEntity entityKey="city" />,
      DEGREES_OF_KINSHIP: <CustomFormAnswerCommonEntity entityKey="kinship" />,
      CIVIL_STATE: <CustomFormAnswerCommonEntity entityKey="civil-state" />,
      STATE: <CustomFormAnswerCommonEntity entityKey="state" />,
      ORGANIZATIONAL_UNIT: <CustomFormAnswerCommonEntity entityKey="organizational-unit" />,
      RACE: <CustomFormAnswerCommonEntity entityKey="race-color" />,
      LEVEL_OF_EDUCATION: <CustomFormAnswerCommonEntity entityKey="education-level" />,
    }

    return possibleEntities[answer.entity as string]
  }, [answer.entity])

  if (!answer.answer) {
    return (
      <Text variant="secondary" fontStyle="italic">
        Nenhum registro enviado
      </Text>
    )
  }

  return <Box>{RenderEntityComponent}</Box>
}
